// Responsável por carregar o script remoto de feedbacks sem uso de inline script.
// Ajuste REACT_APP_ENV nos arquivos .env para selecionar a URL correta.

const env = process.env.REACT_APP_ENV;
const ambiente = env === 'local' || env === 'dev'
  ? 'https://wc-feedbacks-dev.gvdasa.com.br/'
  : env === 'hml'
    ? 'https://wc-feedbacks-hml.gvdasa.com.br/'
    : 'https://wc-feedbacks.gvdasa.com.br/';

(function loadRemoteModule(url: string) {
  if (!url) return;
  const script = document.createElement('script');
  script.type = 'module';
  script.src = url;
  script.crossOrigin = 'anonymous';
  document.head.appendChild(script);
})(ambiente);
